import React from "react";

const css = `
.b {
  fill: #b1b4b3;
}
.c {
  fill: #e8edeb;
}
.d {
  fill: #939997;
}
`;

// SVG dimensions from viewBox
const SVG_WIDTH = 684.66748;
const SVG_HEIGHT = 535.713501;

export const SVG_DIMENSIONS = {
  width: SVG_WIDTH,
  height: SVG_HEIGHT
};

const PhilliesTransactionZoneSvg = ({ children }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        <style>{css}</style>
      </defs>
      
      {/* Border/outline */}
      <path className="d" d="M675.859741,384.099731h-79.451599v-136.040894H213.340027V80.004822l-1.757385-1.757324L137.57782,4.242737l-4.242615-4.242737-4.242554,4.242737L4.242737,129.092651l-4.242737,4.242554,4.242737,4.242615,191.571411,191.571411,1.759888,1.759888,2.48877-.002502,19.200012-.019592,2.841125.006287v74.806396h322.084351v130.013794h137.671448v-151.61377h-6ZM675.859741,529.713501h-125.671448v-130.013794H228.103943v-74.793091l-8.847229-.019592-19.200012.019592L8.485291,133.335205,133.335205,8.485352l74.004822,74.004761v171.568726h383.068115v136.040894h85.451599v139.61377Z"/>
      
      {/* Background fill */}
      <polygon className="c" points="590.408142 390.099731 590.408142 254.058838 207.340027 254.058838 207.340027 82.490112 133.335205 8.485352 8.485291 133.335205 200.056702 324.906616 219.256714 324.887024 228.103943 324.906616 228.103943 399.699707 550.188293 399.699707 550.188293 529.713501 675.859741 529.713501 675.859741 390.099731 590.408142 390.099731"/>
      
      {/* Detail elements */}
      <g>
        <path className="b" d="M186.43585,85.877421l-.245715,107.914006c-.000645.283096.229601.512442.512692.510689l14.130816-.087494c.280174-.001735.506384-.22935.506384-.509529v-107.779256c0-.280733-.227073-.50858-.507805-.509536l-13.885101-.047256c-.281633-.000958-.51063.226742-.511271.508375Z"/>
      </g>
      <g>
        <rect x="587.161621" y="260.058716" width="11.5" height="58.841309"/>
        <rect x="673.16748" y="389.664185" width="11.5" height="140.42334"/>
        <rect x="219.558105" y="260.058716" width="11.5" height="58.841309"/>
        <rect x="219.558105" y="330.93512" width="11.5" height="62.952698"/>
      </g>

      {/* Zone shapes and label injected here */}
      {children}
    </svg>
  );
};

export default PhilliesTransactionZoneSvg;